/**
 * Çizim ölçeği — kalınlık, ok ucu, yazı boyu gibi **dünya biriminde** duran
 * ölçülerin çarpanı.
 *
 * Editörün dünyası 1080 birimdir. Hell Let Loose döneminde bu ~2 km'lik bir
 * haritaydı (1 birim ≈ 1,85 m) ve bütün varsayılanlar (kalınlık 1.5, yazı 20,
 * ok ucu 7…) ona göre seçildi. Wardogs haritası 16.384 m (1 birim ≈ 15,2 m),
 * çatışma ise ~1 km'lik bir kontrol bölgesinde geçiyor: aynı sayılar ekranda
 * ~8 kat kalın çıkıyor, en düşük ayar bile kalın kalıyordu.
 *
 * Arayüzdeki sayılar (kaydırıcılar, kayıttaki `__sw` / `__fs`) değişmedi;
 * çarpan yalnızca haritaya basarken uygulanır. Böylece eski kayıtlar da
 * yeniden yüklenirken kendiliğinden yeni ölçeğe oturur.
 *
 *     1.85 m / 15.17 m ≈ 1/8
 */
export const DRAW_SCALE = 1 / 8
